import {
  SeatMapsInt, SeatmapSectionInt, SeatmapRowInt,
} from "@interfaces/*";
import {Segment} from "@models/micro/segment.model";

export class SeatMap {
    public sectionInfo?: Array<SeatmapSectionInt> = []
    public seatmapRowInt?: Array<SeatmapRowInt> = []
    public segment?: Segment;
    public seatMap?:any;

  constructor(seatMapInfo?: SeatMapsInt) {
  }


public getInfoSeat(code) {
  let codeSeatObj = {}
  this.sectionInfo.map(row => {
  row?.rows.map(seats => {
    seats?.seats.filter(info => {
      if(info.code == code) {
        codeSeatObj = {
          code: info.code,
          section: info.section
         }
      }
    })
  })
 });
  return codeSeatObj;
}

  public getInfoRow() {
    let seatObj = {}
    this.sectionInfo.map(row => {
    });
    return seatObj;
  }

  public getseatInfo() {
    return this.sectionInfo
    }
}
